'use strict';
const mmWidgets = require('./mm-widgets'),
	addHotkey = require('./add-hotkey');

mmWidgets.fn.installHotkeyWidget = function () {
	const hotKeyReplacements = {
			'ALT+': String.fromCharCode(0x2325),
			'SHIFT+': String.fromCharCode(0x21e7),
			'CTRL+': '^',
			'META+': String.fromCharCode(8984),
			'UP': String.fromCharCode(0x2191),
			'DOWN': String.fromCharCode(0x2193),
			'BACKSPACE': String.fromCharCode(0x232b)
		},
		parsedHotkey = function (hotkey) {
			let parsed = hotkey || '';
			Object.keys(hotKeyReplacements).forEach(key => {
				parsed = parsed.replace(hotKeyReplacements[key], key);
			});
			return parsed;
		};

	return mmWidgets.each(this, function () {
		const element = this,
			activate = function (e) {
				if (!element.hasClass('disabled')) {
					if (!element.attr('data-mm-hotkey-propagate')) {
						e.stopPropagation();
						e.preventDefault();
					}
					element.trigger('click');
				}
			},
			target = element.attr('data-mm-install-hotkey'),
			hotkey = parsedHotkey(element.attr('data-mm-hotkey')),
			additionalHotkeys = element.attr('data-mm-additional-hotkeys'),
			targetDom = document.querySelector(target);
		addHotkey(targetDom, hotkey, activate);
		if (additionalHotkeys) {
			addHotkey(targetDom, additionalHotkeys, activate);
		}
	});
};
